module.exports = __webpack_public_path__ + "assets/icon-retainer-task-orange.e4fe4d6c.svg";